import React from "react";
import styled from "styled-components";

const SecondSemesterCourseRegistrationPage = () => {
  return (

    <div>
      <TempText>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
        Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </TempText>
    </div>
  );
}

export default SecondSemesterCourseRegistrationPage;

const TempText = styled('p')` 
  max-width: 700px; 
  width: 100%; 
  font-size: 1rem;
  padding: 1rem; 
  color: white; 
`; 